import React, { Component } from 'react';
import PropTypes from 'prop-types';
import routes from '../../router';

import AlertPopup from './alert-popup';
import ReportPopup from './report-popup';
import VacancyPopup from './vacancy-popup';
import VerifyPopup from './verify-popup';
import NewPassPopup from './new-pass-popup';
import UnpaidPopup from './unpaid-popup';
import FeedbackPopup from './feedback-popup';
import ComplaintPopup from './complaint-popup';

class Popup extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    status: PropTypes.string,
    message: PropTypes.string,
    title: PropTypes.string,
    button: PropTypes.string,
    link: PropTypes.string,
    filmId: PropTypes.number,
    orderId: PropTypes.number,
    reviewId: PropTypes.number,
  };

  render() {
    const { type } = this.props;

    if (type == 'alert') return <AlertPopup {...this.props} />;

    if (type == 'report') return <ReportPopup route={routes.report} />;

    if (type == 'vacancy')
      return <VacancyPopup route={routes.vacancy} {...this.props} />;

    if (type == 'verify')
      return <VerifyPopup route={routes.profile} {...this.props} />;

    if (type == 'new-pass')
      return <NewPassPopup route={routes.auth.setpass} {...this.props} />;

    if (type == 'unpaid') return <UnpaidPopup {...this.props} />;

    if (type == 'feedback') return <FeedbackPopup {...this.props} />;

    if (type == 'feedback-static') return <FeedbackPopup {...this.props} />;

    if (type == 'spam') return <ComplaintPopup {...this.props} />;

    if (type == 'abuse') return <ComplaintPopup {...this.props} />;

    if (type == 'dirty-word') return <ComplaintPopup {...this.props} />;
  }
}

export default Popup;
